import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "../../masterLayout/AdminLayout";
import AdminPageHeader from "../../components/admin/AdminPageHeader";
import { adminApi, handleAdminLogoutIfNeeded } from "../../utils/adminApi";

const AdminTestEmail = () => {
  const [smtp, setSmtp] = useState(null);
  const [form, setForm] = useState({
    to: "",
    subject: "SMTP test email",
    message:
      "This is a test email from the admin panel. If you received it, SMTP is working.",
  });
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    document.title = "Test Email";
    (async () => {
      const res = await adminApi({ url: "admin/smtp-status", method: "GET" });
      if (handleAdminLogoutIfNeeded(res)) return;
      if (res.success) setSmtp(res.data || null);
    })().catch(console.error);
  }, []);

  const sendTest = async (e) => {
    e.preventDefault();
    setSending(true);
    setResult(null);
    try {
      const res = await adminApi({
        url: "admin/test-email",
        method: "POST",
        body: {
          to: form.to.trim(),
          subject: form.subject.trim(),
          message: form.message.trim(),
        },
      });
      if (handleAdminLogoutIfNeeded(res)) return;
      setResult(res);
    } catch (err) {
      setResult({
        success: false,
        msg: err?.message || "Request failed",
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <AdminLayout>
      <div className="admin-ui">
        <AdminPageHeader
          title="Test email"
          subtitle="Send a one-off message using the SMTP settings from Site Settings."
          action={
            <Link to="/admin/settings" className="admin-btn admin-btn-ghost">
              Open Site Settings
            </Link>
          }
        />

        {smtp ? (
          <div
            className={`admin-alert ${
              smtp.configured ? "admin-alert-info" : "admin-alert-danger"
            }`}
          >
            {smtp.configured ? (
              <>
                SMTP ready: <strong>{smtp.smtp_email}</strong> via{" "}
                <strong>
                  {smtp.smtp_host}:{smtp.smtp_port || "587"}
                </strong>
              </>
            ) : (
              <>
                SMTP is not fully configured. Set host, email, and password in{" "}
                <Link to="/admin/settings">Site Settings</Link> first.
              </>
            )}
          </div>
        ) : null}

        {result ? (
          <div
            className={`admin-alert ${
              result.success ? "admin-alert-info" : "admin-alert-danger"
            }`}
          >
            <div>{result.msg || (result.success ? "Sent" : "Failed")}</div>
            {result.details ? (
              <pre
                style={{
                  margin: "8px 0 0",
                  fontSize: 12,
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {JSON.stringify(result.details, null, 2)}
              </pre>
            ) : null}
          </div>
        ) : null}

        <div className="admin-form-card" style={{ maxWidth: 560 }}>
          <div className="admin-form-head">
            <h6>Send test</h6>
            <p>Uses the same nodemailer SMTP path as password recovery and alerts.</p>
          </div>
          <form onSubmit={sendTest}>
            <div className="row g-3">
              <div className="col-12">
                <label className="form-label">To</label>
                <input
                  type="email"
                  className="form-control"
                  value={form.to}
                  onChange={(e) => setForm({ ...form, to: e.target.value })}
                  placeholder="you@example.com"
                  required
                />
              </div>
              <div className="col-12">
                <label className="form-label">Subject</label>
                <input
                  type="text"
                  className="form-control"
                  value={form.subject}
                  onChange={(e) => setForm({ ...form, subject: e.target.value })}
                />
              </div>
              <div className="col-12">
                <label className="form-label">Message</label>
                <textarea
                  className="form-control"
                  rows={5}
                  value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                />
              </div>
            </div>
            <div className="admin-form-actions" style={{ marginTop: 16 }}>
              <button
                type="submit"
                className="admin-btn admin-btn-primary"
                disabled={sending || (smtp && !smtp.configured)}
              >
                {sending ? "Sending…" : "Send test email"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminTestEmail;
